import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import React from 'react'

export interface StepItemProps {
  // cloudinaryImage: any
  builderImage: any
  imgAltText: string
  prominentText: string
  prominentTextColor: string
  descriptionText: string
  descriptionTextColor: string
  isMobile: boolean
}

const StepItem = ({
  // cloudinaryImage,
  builderImage,
  imgAltText = '',
  prominentText,
  prominentTextColor,
  descriptionText,
  descriptionTextColor,
  isMobile
}: StepItemProps) => {
  return (
    <div className="z-index-2 relative block w-full bg-transparent sm:flex sm:flex-row">
      <div className="img-wrapper w-full px-8 sm:w-1/2 md:pl-0 md:pr-1 lg:px-8">
        <CdnImage
          className="w-full"
          url={builderImage}
          alt={imgAltText}
          steps={[350, 130, 200, 275]}
          style={{
            width: builderImage?.width,
            height: '100%',
            maxWidth: '100%',
            dpr: 'auto'
          }}
        />
        {/* {builderImage ? (
          <CdnImage
            className="w-full"
            url={builderImage}
            alt={imgAltText}
            steps={[350, 130, 200, 275]}
            style={{
              width: builderImage?.width,
              height: '100%',
              maxWidth: '100%',
              dpr: 'auto'
            }}
          />
        ) : (
          <CloudinaryImage
            className="w-full"
            publicId={cloudinaryImage?.public_id}
            alt={imgAltText}
            steps={[350, 130, 200, 275]}
            style={{
              width: cloudinaryImage?.width,
              height: '100%',
              maxWidth: '100%',
              dpr: 'auto'
            }}
          />
        )} */}
      </div>
      <div className="text-wrapper flex w-full flex-col justify-center sm:w-1/2">
        <div className={`prominent-text ${isMobile ? 'text-center' : ''}`}>
          <p className="my-2 font-sans font-bold" style={{ color: prominentTextColor }}>
            {prominentText}
          </p>
        </div>
        <div className={`description-text ${isMobile ? 'text-center' : ''}`}>
          <p className="my-2 text-sm" style={{ color: descriptionTextColor }}>
            {descriptionText}
          </p>
        </div>
      </div>
    </div>
  )
}

export default StepItem

export const StepItemRegisterProps = {
  name: 'stepItem',
  type: 'object',
  defaultValue: {
    imgSrc: null,
    imgAltText: '',
    prominentText: 'We source food from our trusted network of farmers',
    prominentTextColor: '#004355',
    descriptionText: 'We source and make delicious food for your dog using the finest ingredients',
    descriptionTextColor: '#000000'
  },
  subFields: [
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    { name: 'imgAltText', type: 'text', defaultValue: '' },
    { name: 'prominentText', type: 'string', defaultValue: 'We source food from our trusted network of farmers' },
    { name: 'prominentTextColor', type: 'color', defaultValue: '#004355' },
    {
      name: 'descriptionText',
      type: 'text',
      defaultValue: 'We source and make delicious food for your dog using the finest ingredients'
    },
    { name: 'descriptionTextColor', type: 'color', defaultValue: '#000000' }
  ]
}
